import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
} from "../../../utils";

export const getFuelSupplyDetailsAPI = (data) => {
  const { id, offset, limit, sortBy, sortDirection } = data;
  return apiGet(`/api/fuel-supply/fetch-posted-fuel-supply-requests/${id}`, { offset, limit, sortBy, sortDirection });
};  

export const addFuelSupplyDetailsAPI = (data) => {
  return apiPost("/api/fuel-supply", data);
};

export const updateFuelSupplyDetailsAPI = (params, data) => {
  return apiPut(`/api/fuel-supply/${params.id}`, data);
};

export const deleteFuelSupplyDetailsAPI = (id) => {
  return apiDelete(`/api/fuel-supply/${id}`);
};

export const generateFuelSupplyRequestAPI = (params, data) => {
  return apiPost(`/api/fuel-supply/generate-request/${params.id}`, data);
};

export const updateFuelSupplyRequestAPI = (params, data) => {
  return apiPut(`/api/fuel-supply/update-request/${params.id}`, data);
};

